module.exports = __webpack_public_path__ + "img/live-arrow-up.svg";